import { useRef, useState, type KeyboardEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@platform/ui';
import { routes } from '@platform/core/lib/routes';

/**
 * Глобальний пошук верхньої панелі (UIUX top-bar «Search box 200–340px», patterns/search): поле-пігулка на напівпрозорому тлі бренду;
 * Enter відкриває сторінку пошуку із запитом, Esc очищає й прибирає фокус (Ctrl/⌘ K — навігатор модулів). На вузьких екранах поле
 * згортається до круглої кнопки, що відкриває сторінку пошуку (як кнопка пошуку прототипу v4).
 */
export function TopSearch() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const input = useRef<HTMLInputElement>(null);
  const [q, setQ] = useState('');
  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && q.trim()) { navigate(routes.search(q.trim())); setQ(''); input.current?.blur(); }
    else if (e.key === 'Escape') { setQ(''); input.current?.blur(); }
  };
  return (
    <>
      <label className="tb-search" title={t('shell.searchTitle')}>
        <Icon name="search" size={15} strokeWidth={2} className="tb-search__icon" />
        <input ref={input} className="tb-search__input" type="search" value={q} placeholder={t('shell.searchPlaceholder')} aria-label={t('shell.searchAll')}
          onChange={(e) => setQ(e.target.value)} onKeyDown={onKeyDown} />
      </label>
      <Link className="po-topbar__icon tb-icon tb-search-btn" to={routes.search()} title={t('shell.searchAll')} aria-label={t('shell.searchAll')}>
        <Icon name="search" size={15} strokeWidth={2} />
      </Link>
    </>
  );
}
